import produce from 'immer';

import {assertAndContinue} from 'Asserts';
import {GraphBuilderObjectType} from 'processes/graph-builder/validation/GraphBuilderConstants';
import {ProcessInteractiveFlowchart} from 'processes/graph-builder-processes/flowchart-viz/ProcessFlowchartVizConstants';
import {
  ProcessFlowchartDesignSpace,
  ProcessFlowchartForValidation,
} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';
import validateProcessGraph from 'processes/graph-builder-processes/validation/validateProcessGraph';

import {getGraphBuilderNodeType} from './getGraphBuilderNodeType';

export default function validateProcessInteractiveFlowchart(
  flowchart: ProcessInteractiveFlowchart,
  designSpace: ProcessFlowchartDesignSpace,
  didInitialFlowchartHaveChainedRouters: boolean
): ProcessInteractiveFlowchart {
  const flowchartForValidation: ProcessFlowchartForValidation = {
    nodes: flowchart.nodes.map((node) => ({
      ...node,
      nodeType: getGraphBuilderNodeType(node, designSpace.flowchartSchema),
    })),
    edges: flowchart.edges.map((edge) => ({
      ...edge,
      toNodeId: edge.toNodeClientId,
      fromNodeId: edge.fromNodeClientId,
    })),
  };

  const validationResult = validateProcessGraph(
    flowchartForValidation,
    designSpace,
    didInitialFlowchartHaveChainedRouters
  );

  return produce(flowchart, (draftFlowchart) => {
    draftFlowchart.nodes = draftFlowchart.nodes.map((node) => ({
      ...node,
      errors: [],
      errorTypes: [],
    }));
    draftFlowchart.edges = draftFlowchart.edges.map((edge) => ({...edge, errors: [], errorTypes: []}));
    for (const error of validationResult.errors) {
      if (error.objectType === GraphBuilderObjectType.NODE) {
        const node = draftFlowchart.nodes.find(({clientId}) => clientId === error.objectId);
        if (node != null) {
          node.errors = [...(node.errors ?? []), error.errorMessage];
          node.errorTypes = [...(node.errorTypes ?? []), error.errorType];
        }
      } else if (error.objectType === GraphBuilderObjectType.EDGE) {
        const edge = draftFlowchart.edges.find(({clientId}) => clientId === error.objectId);
        if (edge != null) {
          edge.errors = [...(edge.errors ?? []), error.errorMessage];
          edge.errorTypes = [...(edge.errorTypes ?? []), error.errorType];
        }
      } else {
        assertAndContinue(false, 'Unexpected flowchart validation error', {error});
      }
    }
  });
}
